<template>
  <v-row>
    <TreeMenu :dataSchedule="dataSchedule" />
    <Segment v-if="showSegmentWindow" class="ml-3" />
    <Elements v-if="showElementWindow" class="ml-3" />
    <Schedule
      v-if="showScheduleWindow && selectedItemId !== null"
      :itemId="selectedItemId"
      class="ml-3"
    />
    <schedule-assistant v-if="showAssistentWindow" />
    <Holidays v-if="showHolidayWindow" class="ml-3" />
    <Groups v-if="showGroupWindow" class="ml-3" />
    <Employees v-if="showEmployeeWindow" class="ml-3" />
    <v-dialog
      v-model="openSchedule"
      max-width="400px"
      persistent
      @keydown.esc="reset(false)"
    >
      <Form
        :items="dataSchedule"
        @save="saveForm"
        @cancel="reset"
        :maxWidth="maxWidth"
        :mode="mode"
      >
      </Form>
    </v-dialog>
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
    />
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Employees from "./Employees.vue";
import Groups from "./Groups.vue";
import Holidays from "./Holidays.vue";
import TreeMenu from "./TreeMenu.vue";
import schedules from "@/store/horarios/schedules";
import Form from "@/components/Complement/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Loader from "@/components/Complement/Loader.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Schedule from "./Schedule.vue";
import Elements from "./Elements.vue";
import Segment from "./Segment.vue";
import ScheduleAssistant from "./ScheduleAssistant.vue";
export default {
  components: {
    Employees,
    Groups,
    Holidays,
    ScheduleAssistant,
    Snackbar,
    Loader,
    TreeMenu,
    Form,
    DeleteDialog,
    Segment,
    Elements,
    Schedule,
  },

  data() {
    return {
      title: this.$tc("schedules.schedule"),
      isLoading: true,
      color: "",
      alert: false,
      textAlert: "",
      titleDelete: this.$tc("schedules.toSchedule"),
      dataSchedule: [
        {
          name: "name",
          label: this.$tc("schedules.nameSchedule"),
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) => v.length <= 50 || this.$tc("schedules.rulesDataSchedules"),
          ],
        },
      ],
      maxWidth: "400px",
      showCard: true,
      itemToDelete: null,
      itemId: null,
      filteredSchedules: [],
    };
  },
  mounted() {
    schedules.dispatch("getSchedules").then(() => {
      this.isLoading = false;
    });
    schedules.dispatch("handleShowWindow", "assistent");
  },

  computed: {
    scheduleAll() {
      return this.filteredSchedules.length > 0
        ? this.filteredSchedules
        : schedules.state.schedules;
    },
    schedules() {
      return schedules.state.schedules;
    },
    padding() {
      return schedules.state.paddingNav;
    },
    mode: {
      get() {
        return schedules.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    openSchedule: {
      get() {
        return schedules.state.openSchedule.value;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return schedules.state.openDeleteSch;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    selectedItemId() {
      return schedules.state.scheduleId;
    },
    showScheduleWindow() {
      return schedules.state.showScheduleWindow;
    },
    showElementWindow() {
      return schedules.state.showElementWindow;
    },
    showSegmentWindow() {
      return schedules.state.showSegmentWindow;
    },
    showAssistentWindow() {
      return schedules.state.showAssistentWindow;
    },
    showGroupWindow() {
      return schedules.state.showGroupsWindow;
    },
    showHolidayWindow() {
      return schedules.state.showHolidaysWindow;
    },
    showEmployeeWindow() {
      return schedules.state.showEmployeesWindow;
    },
  },
  methods: {
    saveForm(items) {
      const type = schedules.state.openSchedule;
      switch (type.type) {
        case "add":
          this.addSchedule(items);
          break;
        case "edit":
          const payload = {
            id: schedules.state.editSchedule,
            name: items.name,
          };
          this.editSchedule(payload);
          break;
        case "copy":
          const data = {
            id: schedules.state.editSchedule,
            name: items.name,
          };
          this.copySchedule(data);
          break;
        default:
          break;
      }
    },

    reset(value) {
      schedules.commit("setOpenSchedule", value);
      schedules.commit("setOpenElement", value);
      this.dataSchedule.forEach((item) => {
        item.data = "";
      });
    },

    deleteItem() {
      schedules
        .dispatch("deleteSchedule")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.deleteSchedule");
        })
        .catch((e) => {
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = e.response.data.error.message;
        });
      this.resetDelete();
    },
    resetDelete() {
      this.openDelete = false;
      schedules.commit("setOpenDeleteSch", false);
      this.alert = false;
    },
    cancelDelete() {
      this.openDelete = false;
      schedules.commit("setOpenDeleteSch", false);
    },
    addSchedule(items) {
      schedules.commit("setNewSchedule", items);
      schedules
        .dispatch("newSchedule")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.addScheduleAlert");
        })
        .catch((e) => {
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = e.response.data.error.message;
        });
      this.reset(false);
    },
    editSchedule(item) {
      let payload = {
        name: item.name,
        id: item.id,
      };
      schedules.commit("setEditItemsSchedule", payload);
      schedules
        .dispatch("editSchedule")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.editScheduleAlert");
        })
        .catch((e) => {
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = e.response.data.error.message;
        });
      this.reset(false);
    },
    copySchedule(item) {
      let payload = {
        name: item.name,
        id: item.id,
      };
      schedules.commit("setEditItemsSchedule", payload);
      schedules
        .dispatch("copySchedule")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.copyScheduleAlert");
        })
        .catch((e) => {
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = e.response.data.error.message;
        });
      this.reset(false);
    },
  },
};
</script>
<style scoped>
.card_container {
  min-height: 450px;
}

.no-search {
  text-align: center !important;
  height: 300px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (min-width: 1000px) and (max-width: 1400px) {
  .card_container {
    max-height: 450px !important;
    overflow-y: scroll !important;
    overflow-x: hidden;
  }
}

@media (min-width: 1400px) and (max-width: 1800px) {
  .card_container {
    max-height: 750px !important;
    overflow-y: scroll !important;
    overflow-x: hidden;
    padding-bottom: 10px !important;
  }
}
</style>
